import {Integration} from './integration';

export class OneClickLCA {
  integrations = new Integration();
}
